module.exports = __webpack_public_path__ + "static/media/icon_circleX_dark.9991e6f9.svg";